/** Reduce Motion (STANDARDS S4, DESIGN §4): read once where a moment starts; CSS also turns the motion off by itself. */
export function prefersReducedMotion(): boolean {
  try { return typeof window !== "undefined" && !!window.matchMedia?.("(prefers-reduced-motion: reduce)").matches; } catch { return false; }
}

/** Scroll to a section: smooth, or a jump under Reduce Motion. */
export function scrollToSection(el: Element | null | undefined) {
  try { el?.scrollIntoView?.({ behavior: prefersReducedMotion() ? "auto" : "smooth", block: "start" }); } catch { /* old browsers: no scroll */ }
}

/** The check's ring-and-tick draw: 60 ms delay + 220 ms (styles.css --dur-delay-draw, --dur-draw), rounded up. */
export const CHECK_DRAW_MS = 300;

/**
 * Run `fn` once the check that just flipped has finished drawing, so the list does not drop the row in the middle of it. Only the
 * list refresh waits, never the save, the toast or the next tap. Under Reduce Motion there is no draw to wait for: runs at once.
 */
export function afterCheckDraw(fn: () => void) {
  if (prefersReducedMotion()) fn(); else setTimeout(fn, CHECK_DRAW_MS);
}

/**
 * A progress fill that moves by transform, not width (motion audit fix 13): the fill is always full width and slides in from the
 * left (`translateX(-(1-p)*100%)`), so nothing is laid out again per frame and the rounded end keeps its shape.
 * `p` is 0..1 and is clamped. Pair with a track that has `overflow: hidden` and a fill with `transition: transform`.
 */
export function barFill(p: number): { width: string; transform: string } {
  const f = Number.isFinite(p) ? Math.min(1, Math.max(0, p)) : 0;
  return { width: "100%", transform: `translateX(${(f - 1) * 100}%)` };
}
